import React, { useMemo } from 'react';

// Frases motivacionales
const motivationalQuotes = [
  "El éxito es la suma de pequeños esfuerzos repetidos día tras día.",
  "La excelencia no es un acto, sino un hábito.",
  "Cada día es una nueva oportunidad para mejorar.",
  "El único modo de hacer un gran trabajo es amar lo que haces.",
  "La innovación distingue a los líderes de los seguidores.",
  "El futuro pertenece a quienes creen en la belleza de sus sueños.",
  "La tecnología mejor es aquella que conecta a las personas.",
  "Monitorear es prevenir, prevenir es cuidar.",
  "La calidad nunca es un accidente, siempre es el resultado de un esfuerzo inteligente.",
  "Los datos son el nuevo petróleo del siglo XXI.",
  "Simplicidad es la máxima sofisticación.",
  "El agua es vida, monitorearla es protegerla.",
];

export const Footer = () => {
  // Frase aleatoria que cambia solo al recargar la página
  const randomQuote = useMemo(() => {
    const index = Math.floor(Math.random() * motivationalQuotes.length);
    return motivationalQuotes[index];
  }, []);

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <span className="footer-logo">🐕</span>
          <span className="footer-company">Desarrollado por <strong>Alphiesoft</strong></span>
        </div>
        <div className="footer-quote">
          <span className="quote-icon">💬</span>
          <span className="quote-text">"{randomQuote}"</span>
        </div>
        <div className="footer-copyright">
          © {new Date().getFullYear()} Todos los derechos reservados
        </div>
      </div>
    </footer>
  );
};
